import * as z from 'zod';

export const CreateMemberRoleDefinitionRequest = /*#__PURE__*/ z.object({
  roleKey: z
    .string()
    .describe(
      'Unique key that identifies the role. Must be uppercase (e.g. `"WRITER"`).'
    ),
  options: z.object({
    roleTitle: z
      .string()
      .describe('Display name of the role shown to site members.'),
    blockable: z
      .boolean()
      .describe('When `true`, the role cannot be assigned to blocked members.')
      .optional(),
  }),
});
export const CreateMemberRoleDefinitionResponse = /*#__PURE__*/ z.object({
  role: z
    .object({
      _id: z
        .string()
        .describe('Role definition ID.')
        .regex(
          /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
          'Must be a valid GUID'
        )
        .optional(),
      roleKey: z
        .string()
        .describe(
          'Unique key that identifies the role. Used when assigning and unassigning roles to members.'
        )
        .optional(),
      title: z
        .string()
        .describe('Display name of the role shown to site members.')
        .optional(),
      blockable: z
        .boolean()
        .describe(
          'When `true`, the role cannot be assigned to blocked members.'
        )
        .optional(),
      revision: z
        .string()
        .regex(/^\d+$/, 'Must be a valid UInt64 string')
        .describe(
          'Revision number, used for checking the optimistic lock condition during updates.'
        )
        .optional()
        .nullable(),
    })
    .describe('Created role definition.')
    .optional(),
});
export const ListMemberRoleDefinitionsRequest = /*#__PURE__*/ z.object({});
export const ListMemberRoleDefinitionsResponse = /*#__PURE__*/ z.object({
  roles: z
    .array(
      z.object({
        _id: z
          .string()
          .describe('Role definition ID.')
          .regex(
            /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
            'Must be a valid GUID'
          )
          .optional(),
        roleKey: z
          .string()
          .describe(
            'Unique key that identifies the role. Used when assigning and unassigning roles to members.'
          )
          .optional(),
        title: z
          .string()
          .describe('Display name of the role shown to site members.')
          .optional(),
        blockable: z
          .boolean()
          .describe(
            'When `true`, the role cannot be assigned to blocked members.'
          )
          .optional(),
        revision: z
          .string()
          .regex(/^\d+$/, 'Must be a valid UInt64 string')
          .describe(
            'Revision number, used for checking the optimistic lock condition during updates.'
          )
          .optional()
          .nullable(),
      })
    )
    .optional(),
});
export const GetMemberRoleDefinitionRequest = /*#__PURE__*/ z.object({
  roleKey: z.string().describe('Key of the role definition to retrieve.'),
});
export const GetMemberRoleDefinitionResponse = /*#__PURE__*/ z.object({
  role: z
    .object({
      _id: z
        .string()
        .describe('Role definition ID.')
        .regex(
          /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
          'Must be a valid GUID'
        )
        .optional(),
      roleKey: z
        .string()
        .describe(
          'Unique key that identifies the role. Used when assigning and unassigning roles to members.'
        )
        .optional(),
      title: z
        .string()
        .describe('Display name of the role shown to site members.')
        .optional(),
      blockable: z
        .boolean()
        .describe(
          'When `true`, the role cannot be assigned to blocked members.'
        )
        .optional(),
      revision: z
        .string()
        .regex(/^\d+$/, 'Must be a valid UInt64 string')
        .describe(
          'Revision number, used for checking the optimistic lock condition during updates.'
        )
        .optional()
        .nullable(),
    })
    .describe('Retrieved role definition.')
    .optional(),
});
export const UpdateMemberRoleDefinitionRequest = /*#__PURE__*/ z.object({
  key: z.string().describe('Key of the role definition to update.'),
  options: z.object({
    blockable: z
      .boolean()
      .describe('Whether the role can be assigned to blocked members.')
      .optional(),
    revision: z
      .string()
      .regex(/^\d+$/, 'Must be a valid UInt64 string')
      .describe(
        'Current revision number. Prevents conflicting concurrent updates.'
      ),
  }),
});
export const UpdateMemberRoleDefinitionResponse = /*#__PURE__*/ z.object({
  role: z
    .object({
      _id: z
        .string()
        .describe('Role definition ID.')
        .regex(
          /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
          'Must be a valid GUID'
        )
        .optional(),
      roleKey: z
        .string()
        .describe(
          'Unique key that identifies the role. Used when assigning and unassigning roles to members.'
        )
        .optional(),
      title: z
        .string()
        .describe('Display name of the role shown to site members.')
        .optional(),
      blockable: z
        .boolean()
        .describe(
          'When `true`, the role cannot be assigned to blocked members.'
        )
        .optional(),
      revision: z
        .string()
        .regex(/^\d+$/, 'Must be a valid UInt64 string')
        .describe(
          'Revision number, used for checking the optimistic lock condition during updates.'
        )
        .optional()
        .nullable(),
    })
    .describe('Updated role definition.')
    .optional(),
});
export const DeleteMemberRoleDefinitionRequest = /*#__PURE__*/ z.object({
  roleKey: z.string().describe('Key of the role definition to delete.'),
});
export const DeleteMemberRoleDefinitionResponse = /*#__PURE__*/ z.object({});
